<template>
  <vs-sidebar click-not-close position-right parent="body" default-index="1" color="primary"
    class="add-new-data-sidebar items-no-padding" spacer v-model="isSidebarActiveLocal" v-esc="escape">
    <div class="w-full" @keyup.enter="submitData">
      <div class="mt-6 flex items-center justify-between px-6">
      <h4>{{ Object.entries(this.data).length === 0 ? "Yeni Tedarikçi" : "Tedarikçi Düzenle" }}</h4>
      <feather-icon icon="XIcon" @click.stop="isSidebarActiveLocal = false" class="cursor-pointer"></feather-icon>
    </div>
    <vs-divider class="mb-0"></vs-divider>
    <VuePerfectScrollbar class="scroll-area--data-list-add-new" :settings="settings">
      <form data-vv-scope="form-1">
        <div class="px-6">

          <vs-input id="name" name="İsim" v-validate="'required|min:2|max:40'" v-model="newSupplier.name" class="w-full"
            icon-pack="feather" icon="icon-user" label-placeholder="Tedarikçi İsmi" />
          <span class="text-danger text-sm" v-show="errors.has('form-1.İsim')">{{ errors.first('form-1.İsim') }}</span>

          <vs-input id="ownerName" name="Yetkili İsmi" v-validate="'min:2|max:40'"
            v-model="newSupplier.ownerName" class="w-full" icon-pack="feather" icon="icon-user"
            label-placeholder="Tedarikçi Yetkili İsmi" />
          <span class="text-danger text-sm"
            v-show="errors.has('form-1.Yetkili İsmi')">{{ errors.first('form-1.Yetkili İsmi') }}</span>

          <vs-input id="email" name="Email" v-validate="'email|min:4|max:50'" type="email" v-model="newSupplier.email"
            class="w-full" icon-pack="feather" icon="icon-mail" label-placeholder="Email" />
          <span class="text-danger text-sm"
            v-show="errors.has('form-1.Email')">{{ errors.first('form-1.Email') }}</span>

          <vs-input id="phone" name="Telefon" v-mask="phoneMask" v-validate="'length:14'" v-model="newSupplier.phoneNumber" class="w-full"
            icon-pack="feather" icon="icon-phone" label-placeholder="Telefon" />
          <span class="text-danger text-sm"
            v-show="errors.has('form-1.Telefon')">{{ errors.first('form-1.Telefon') }}</span>

          <vs-input id="fax" name="Fax" v-mask="faxMask" v-validate="'length:14'" v-model="newSupplier.fax" class="w-full" icon-pack="feather" icon="icon-phone"
            label-placeholder="Fax" />
            <span class="text-danger text-sm"
            v-show="errors.has('form-1.Fax')">{{ errors.first('form-1.Fax') }}</span>

          <vs-textarea id="Adres" name="Adres" v-model="newSupplier.address" class="w-full mt-4 mb-0" label="Adres" />

          <v-select id="bank" name="Banka" v-model="newSupplier.bank" itemid="id" label="name"
            placeholder="Banka Seçimi.." :options="banks" class="mt-4" :clearable="true"></v-select>
          <span class="text-danger text-sm"
            v-show="errors.has('form-1.Banka')">{{ errors.first('form-1.Banka') }}</span>

          <vs-textarea id="bankAccount" name="Hesap Bilgileri" v-model="newSupplier.bankAccount"
            class="w-full mt-4 mb-0" icon-pack="feather" icon="icon-calendar" label="Banka Hesap Bilgileri" />
          <span class="text-danger text-sm"
            v-show="errors.has('form-1.Hesap Bilgileri')">{{ errors.first('form-1.Hesap Bilgileri') }}</span>

          <vs-textarea id="description" name="Açıklama" v-model="newSupplier.description" class="w-full mt-4 mb-0"
            icon-pack="feather" icon="icon-calendar" label="Açıklama" />

        </div>
      </form>
      <div class="flex mt-5 px-6 pb-4">
        <vs-button class="mr-auto" type="gradient" color="danger" @click="isSidebarActiveLocal = false">
          Vazgeç
        </vs-button>
        <vs-button class="ml-auto" color="success" @click="submitData">Kaydet</vs-button>
      </div>
    </VuePerfectScrollbar>
    </div>
  </vs-sidebar>
</template>

<script>
  import VuePerfectScrollbar from 'vue-perfect-scrollbar'
  import {
    createNewSupplier,
    updateSupplier
  } from '@/api/Supplier';
  export default {
    props: {
      isSidebarActive: {
        type: Boolean,
        required: true
      },
      data: {
        type: Object,
        default: () => {},
      }
    },
    data() {
      return {
        banks: ['Ziraat', 'Garanti', 'HSBC', 'Vakıfbank', 'Finansbank', 'Yapıkredi', 'TEB', 'Halkbank'],
        phoneMask: "#### ### ## ##",
        faxMask: "#### ### ## ##",
        newSupplier: {
          fax: "",
          phoneNumber: "",
          bank: ""
        },

        settings: { // perfectscrollbar settings
          maxScrollbarLength: 60,
          wheelSpeed: .60,
        },
      }
    },
    computed: {
      isSidebarActiveLocal: {
        get() {
          return this.isSidebarActive
        },
        set(val) {
          if (!val) {
            this.$emit('closeSidebar')
            this.$validator.reset()
            this.initValues()
          }
        }
      }
    },
    methods: {
      escape(){
        if(this.isSidebarActiveLocal == true) this.isSidebarActiveLocal = false;
      },
      initValues() {
        this.newSupplier = {
          fax: "",
          phoneNumber: "",
          bank: ""
        };
      },
      submitData: async function () {
        let checker;
        checker = await this.$validator.validateAll('form-1');
        if (checker) {
          //await this.mapNewSupplier();
          if (this.newSupplier.id) {
            updateSupplier(this.newSupplier).then(res => {
              if (res && res.status == 200) {
                this.$store.dispatch("supplier/updateSupplier", res.data).then(data => {
                  this.$vs.notify({
                    color: 'success',
                    title: 'Başarılı !',
                    text: 'Tedarikçi Güncellendi !'
                  });
                  this.$emit('closeSidebar');
                  this.initValues();
                  this.$validator.reset();
                }).catch(err => {
                  console.error(err)
                });
              } else {
                this.$vs.notify({
                  color: 'danger',
                  title: 'Hata : ' + res.status,
                  text: 'Tedarikçi Güncellenemedi !'
                });
              }
            }).catch(() => {
              this.$vs.notify({
                color: 'danger',
                title: 'Hata !',
                text: 'Sunucu Bağlantı Hatası !'
              });
            });
          } else {
            this.newSupplier.id = 0;
            this.newSupplier.rawMaterial = [];
            createNewSupplier(this.newSupplier).then(res => {
              if (res && res.status == 200) {
                this.$store.dispatch("supplier/addSupplier", res.data).then(data => {
                  this.$vs.notify({
                    color: 'success',
                    title: 'Başarılı !',
                    text: 'Yeni Tedarikçi Oluşturuldu !'
                  });
                  this.$emit('closeSidebar');
                  this.initValues();
                  this.$validator.reset();
                });
              } else {
                this.$vs.notify({
                  color: 'danger',
                  title: 'Hata : ' + res.status,
                  text: 'Tedarikçi Kayıt Edilemedi !'
                });
              }
            }).catch(() => {
              this.$vs.notify({
                  color: 'danger',
                  title: 'Hata !',
                  text: 'Sunucu Bağlantı Hatası !'
                });
            });
          }
        }
      },
      mapNewSupplier: async function () {
        //map
      }
    },
    components: {
      VuePerfectScrollbar
    },
    watch: {
      isSidebarActive: function (val) {
        if (!val) return
        if (Object.entries(this.data).length === 0) {
          this.initValues();
          this.$validator.reset();
        } else {
          this.newSupplier = _.cloneDeep(this.data); //Şurda
        }
      }
    },
    created: function () {
    },
  }

</script>

<style lang="scss" scoped>
  .vs__dropdown-menu {
    max-height: 25vh !important;
    overflow-x: hidden !important;
    overflow-y: scroll !important;
    position: absolute!important;
  }
  .style-chooser .vs__dropdown-menu {
    background: #dfe5fb;
    border: none;
    color: red;
    text-transform: lowercase;
    font-variant: small-caps;
  }

  .add-new-data-sidebar {
    ::v-deep .vs-sidebar--background {
      z-index: 52010;
    }

    ::v-deep .vs-sidebar {
      z-index: 52010;
      width: 400px;
      max-width: 90vw;

      .img-upload {
        margin-top: 2rem;

        .con-img-upload {
          padding: 0;
        }

        .con-input-upload {
          width: 100%;
          margin: 0;
        }
      }
    }
  }

  .tabPager {
    background-color: darkgreen;
    border-radius: 50%;
  }

</style>
